import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap';

import classes from './Header.css';
import { logo } from '../../assets/img/img';
// import logo from '../../assets/img/logo.jpg';

const header = props => (
  <header>
    <div className={classes.MiddleSection}>
      <div className={classes.loggedWrap}>
        <div className={classes.alignLeft}>
          <NavLink to="/" className={classes.LogoLink}>
            <img src={logo} alt="Smart Bar" className={classes.Logo} />
          </NavLink>
        </div>
        {props.isAuth && props.userInfo ?
          <div className={classes.alignright}>
            {/* <div className={classes.Notifications} /> */}
            <Dropdown
              isOpen={props.dropdownOpen}
              toggle={() => props.toggleDropdown()}
            >
              <DropdownToggle>
                <div className={props.dropdownOpen ? [classes.Profile, classes.Open].join(' ') : classes.Profile}>
                  <div className={classes.Avatar}>
                    {props.userInfo.image && <img alt="avatar" src={props.userInfo.image} />}
                  </div>
                  <div className={classes.Description}>
                    <p>{props.userInfo.name}</p>
                    <p className={classes.Role}>{props.userInfo.role}</p>
                  </div>
                </div>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>
                  <NavLink to="/admin/account">My Account</NavLink>
                </DropdownItem>
                <DropdownItem>
                  <NavLink to="/logout">Logout</NavLink>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          :
          <div className={classes.Hide}>Empty</div>
        }
      </div>
    </div>
  </header>
);

header.propTypes = {
  isAuth: PropTypes.bool.isRequired,
  dropdownOpen: PropTypes.bool.isRequired,
  toggleDropdown: PropTypes.func.isRequired,
  userInfo: PropTypes.shape().isRequired
};

const mapStateToProps = state => ({
  isAuth: state.auth.authKey !== null
});

export default withRouter(connect(mapStateToProps)(header));
